"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WOMAN = exports.TRANS_WOMAN = exports.TRANS_MAN = exports.TRANS = exports.MAN = exports.GENDER_QUEER = exports.AGENDER = void 0;
exports.AGENDER = "agender";
exports.GENDER_QUEER = "genderQueer";
exports.MAN = "man";
exports.TRANS = "trans";
exports.TRANS_MAN = "transMan";
exports.TRANS_WOMAN = "transWoman";
exports.WOMAN = "woman";